import { atom } from "jotai";
import { uniqBy } from "lodash";
import { convertRRuleToDescription } from "../utils/Common/courseUtils";
import { MB_SERVICE_CLASSIFICATION_GROUP } from "../utils/Constants";

export const selectedProviderAtom = atom(null);

const isServiceFullyBooked = (service) => {
  if (!service?.Settings) return false;
  try {
    const settings =
      typeof service.Settings === "string"
        ? JSON.parse(service.Settings)
        : service.Settings;
    if (settings.maxBookings == null) return false;
    return (settings.scheduledBookings ?? 0) >= settings.maxBookings;
  } catch {
    return false;
  }
};

export const selectedProviderServicesAtom = atom((get) => {
  const provider = get(selectedProviderAtom);
  if (provider && provider.servicetypes && provider.servicetypes.items) {
    const providerServices = uniqBy(
      provider.servicetypes.items.map((item) => item.servicetype),
      "id",
    );
    const activeProviderServices = providerServices.filter((service) => {
      return (
        service.active !== false &&
        service.deleted !== true &&
        service.isVisible !== false &&
        !isServiceFullyBooked(service)
      );
    });
    const sortedServices = activeProviderServices.sort((s1, s2) => {
      if (s1?.category?.ordinal > s2?.category?.ordinal) return 1;
      if (s1?.category?.ordinal < s2?.category?.ordinal) return -1;
      if (s1?.category?.id === s2?.category?.id) {
        if (s1.ordinal > s2.ordinal) return 1;
        if (s1.ordinal < s2.ordinal) return -1;
        return 0;
      }
      return 0;
    });

    return sortedServices;
  }

  return [];
});

export const allServicesAtom = atom(null);

export const allActiveServicesAtom = atom((get) => {
  const allServices = get(allServicesAtom);
  if (!allServices || !Array.isArray(allServices)) {
    return [];
  }

  const activeServices = allServices.filter((service) => {
    return (
      service.active !== false &&
      service.deleted !== true &&
      service.isVisible !== false &&
      !isServiceFullyBooked(service)
    );
  });

  return activeServices;
});

export const allPublicServicesAtom = atom((get) => {
  const activeServices = get(allActiveServicesAtom);
  if (!activeServices || !Array.isArray(activeServices)) {
    return [];
  }
  const publicServices = activeServices.filter(
    (service) => service.behavior !== "INTERNAL",
  );

  return publicServices;
});

export const selectedCourseAssignmentAtom = atom(null);

export const selectedCourseAssignmentRecurrenceDescriptionAtom = atom((get) => {
  const courseSchedule = get(selectedCourseAssignmentAtom);
  return courseSchedule
    ? convertRRuleToDescription(
        courseSchedule.rrule,
        courseSchedule.startDate,
        courseSchedule.endDate,
      )
    : "";
});

export const selectedServiceAtom = atom(null);

export const isCourseAtom = atom(
  (get) =>
    get(selectedServiceAtom)?.Classification ===
    MB_SERVICE_CLASSIFICATION_GROUP,
);

export const courseDatesAtom = atom([]);
export const courseDatesQueryParamsAtom = atom(null);

export const allCompanyLocationsAtom = atom(null);
export const hasCompanyLocationsAtom = atom(
  (get) => get(allCompanyLocationsAtom)?.length,
);
